import type { CSSProperties } from 'react';
import { T } from '@territory/tokens';

/* Exact shared sample actions. Product roles also emit in Marketing's pre-paint block. */
export const MARKETING_SAMPLE_ACTION_ROLES = ['font', 'ink', 'edge', 'on-accent', 'ease'] as const;
const role = (name: typeof MARKETING_SAMPLE_ACTION_ROLES[number]): string => `var(--rv-sample-action-${name})`;

export function marketingSampleActionStyle(primary: boolean): CSSProperties {
  return {
    padding: '7px 14px',
    borderRadius: 10,
    fontFamily: role('font'),
    fontSize: 12.5,
    fontWeight: 700,
    cursor: 'pointer',
    border: primary ? 'none' : `0.5px solid ${role('edge')}`,
    background: primary ? T.accent : 'transparent',
    color: primary ? role('on-accent') : role('ink'),
  };
}

export function marketingSampleActionCss(sel: string): string {
  return `${sel} { transition: transform 140ms ${role('ease')}; -webkit-tap-highlight-color: transparent; }
${sel}:active { transform: scale(0.97); }
${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 3px; }
@media (prefers-reduced-motion: reduce) { ${sel} { transition: none; } }`;
}
